export const loanTypeLabel = {
  fha: 'FHA',
  conforming: 'Conventional loan',
  va: 'VA',
}
